import ImageGallery from '../../component/ImageGallery';
import Project from '../../component/Project';
import worldTradeCentreData from '../../data/HaiAlNaseem.json';
const HaiAlNaseem = () => {
  const { pageData, containerData, content, images,imagesGallery,imagesGalleryleft, styles } = worldTradeCentreData;
  return (<>
      <Project pageData={pageData} containerData={containerData} content={content} images={images} styles={styles} />\
      <ImageGallery imagesGallery={imagesGallery} imagesGalleryleft={imagesGalleryleft} />
      </>
 )
}

export default HaiAlNaseem
